<template>
  <div>
    <component v-if="fieldComponent" :class="{ 'alternate': index % 2 }" :is="fieldComponent" :field="field" />
  </div>
</template>

<script>
  import DefaultFieldType from './DefaultFieldType'
  import ExecutionIdFieldType from './ExecutionIdFieldType'
  import PreviousVersionIdFieldType from './PreviousVersionIdFieldType'

  export default {
    props: {
      field: Object,
      index: Number,
    },
    computed: {
      fieldComponent() {
        if (!this.field) return null

        switch (this.field.Field) {
        case 'PreviousVersionId':
          return PreviousVersionIdFieldType
        case 'ExecutionId':
          return ExecutionIdFieldType
        default:
          return DefaultFieldType
        }
      },
    },
  }
</script>